import React, { useEffect, useState } from 'react';

import hec from '../../../../Assets/Linkages/InternationalConferences/Partners/01-hec.jpg';
import ncgsa from '../../../../Assets/Linkages/InternationalConferences/Partners/02-ncgsa.jpg';
import apsco from '../../../../Assets/Linkages/InternationalConferences/Partners/03-apsco.png';
import isnet from '../../../../Assets/Linkages/InternationalConferences/Partners/04-isnet.jpg';
import baria from '../../../../Assets/Linkages/InternationalConferences/Partners/05-baria.jpg';
import minoSpace from '../../../../Assets/Linkages/InternationalConferences/Partners/06-mino-space.png';
import uraan from '../../../../Assets/Linkages/InternationalConferences/Partners/07-uraan.jpg';
import psf from '../../../../Assets/Linkages/InternationalConferences/Partners/08-psf.jpg';
import ieee from '../../../../Assets/Linkages/InternationalConferences/Partners/09-ieee.jpg';
import tsa from '../../../../Assets/Linkages/InternationalConferences/Partners/10-tsa.png';
import azercosmos from '../../../../Assets/Linkages/InternationalConferences/Partners/11-azercosmos.png';
import sgac from '../../../../Assets/Linkages/InternationalConferences/Partners/12-sgac.jpg';
import npu from '../../../../Assets/Linkages/InternationalConferences/Partners/13-npu.jpg';
import keoScientific from '../../../../Assets/Linkages/InternationalConferences/Partners/14-keo-scientific.jpg';
import iran from '../../../../Assets/Linkages/InternationalConferences/Partners/15-iran.png';

const partners = [
  ['HEC', hec], ['NCGSA', ncgsa], ['APSCO', apsco], ['ISNET', isnet],
  ['Bahria University', baria], ['MinoSpace', minoSpace], ['Uraan Pakistan', uraan],
  ['Pakistan Science Foundation', psf], ['IEEE', ieee], ['Turkish Space Agency', tsa],
  ['Azercosmos', azercosmos], ['SGAC', sgac], ['NPU', npu],
  ['KEO Scientific', keoScientific], ['Iranian partner', iran],
];

const visibleCount = () => {
  if (window.innerWidth < 600) return 1;
  if (window.innerWidth < 900) return 2;
  if (window.innerWidth < 1250) return 3;
  return 5;
};

const PartnersSponsors = () => {
  const [start, setStart] = useState(0);
  const [visible, setVisible] = useState(visibleCount);

  useEffect(() => {
    const resize = () => setVisible(visibleCount());
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => setStart((current) => (current + 1) % partners.length), 2000);
    return () => window.clearInterval(timer);
  }, []);

  const shown = Array.from({ length: visible }, (_, index) => partners[(start + index) % partners.length]);

  return (
    <section className="icast-partners-section" aria-labelledby="icast-partners-title">
      <div className="icast-partners-inner">
        <p className="section-eyebrow">COLLABORATION THAT MOVES SPACE FORWARD</p>
        <h2 id="icast-partners-title">Partners &amp; Sponsors</h2>
        <div className="world-space-week-title-line" aria-hidden="true" />
        <div className="icast-partners-slider" aria-live="off">
          {shown.map(([name, logo], index) => (
            <div className="icast-partner-card" key={`${name}-${start}-${index}`}>
              <img src={logo} alt={`${name} logo`} loading="lazy" />
            </div>
          ))}
        </div>
        <div className="icast-partners-controls">
          <button type="button" onClick={() => setStart((start - 1 + partners.length) % partners.length)} aria-label="Previous partners">←</button>
          <span>{String(start + 1).padStart(2, '0')} / {partners.length}</span>
          <button type="button" onClick={() => setStart((start + 1) % partners.length)} aria-label="Next partners">→</button>
        </div>
      </div>
    </section>
  );
};

export default PartnersSponsors;
